// ── DeckWidgets — сводка дня в боковом меню темы «Колода» (по макету пользователя) ─────
// «Повторить сегодня» (крупное пиксельное число, к повторению / новых, красная «Начать»),
// «План на сегодня» (сделано / всего, полоса) и «Стрик» (золотом, рекорд). На телефоне меню
// нет — те же виджеты стоят вверху главной (compact: в ряд).
//
//   <DeckWidgets C={C} cards={карточки изучаемого языка} onStart={() => …} compact />

import { t } from '../i18n';
import Icon from '../Icon';
import { SANS } from '../themes';
import { Button } from '../ui';
import { panelSurface } from '../ui/surface';
import { ruPlural } from '../utils';
import { planMins, readStreak, useTodayPlan } from './Today';

export default function DeckWidgets({ C, cards, onStart, compact = false }) {
  const plan = useTodayPlan(cards || []);
  const streak = readStreak();
  const pct = plan.all ? Math.round((plan.done / plan.all) * 100) : 0;
  const box = { ...panelSurface(C), borderRadius: 10, padding: '12px 10px', boxSizing: 'border-box', minWidth: 0, fontFamily: SANS };
  const well = { background: C.surface, borderRadius: 6, padding: '8px 6px 7px', minWidth: 0, flex: '1 1 0' };
  const mins = planMins(plan.total);

  const review = (
    <div data-panel="" style={box}>
      <div style={{ fontSize: 14.5, fontWeight: 600, color: C.text, marginBottom: 8 }}>{t("Повторить сегодня")}</div>
      {/* как на макете: крупное число, справа от него — «карточек» и «≈ N минут» */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
        <span data-display="" style={{ fontSize: 34, lineHeight: 1, color: C.gold || C.warm }}>{plan.total}</span>
        <span style={{ minWidth: 0 }}>
          <span style={{ display: 'block', fontSize: 13, color: C.text }}>{ruPlural(plan.total, t("карточка"), t("карточки"), t("карточек"))}</span>
          <span style={{ display: 'block', fontSize: 12, color: C.faint, marginTop: 1 }}>{t("≈ {0} {1}", [mins, ruPlural(mins, t("минута"), t("минуты"), t("минут"))])}</span>
        </span>
      </div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
        <div style={well}>
          <div style={{ fontSize: 17, fontWeight: 700, color: C.danger }}>{plan.repeat}</div>
          <div style={{ fontSize: 11, lineHeight: 1.3, color: C.faint }}>{t("к повторению")}</div>
        </div>
        <div style={well}>
          <div style={{ fontSize: 17, fontWeight: 700, color: C.blueDark }}>{plan.fresh}</div>
          <div style={{ fontSize: 11, lineHeight: 1.3, color: C.faint }}>{t("новых")}</div>
        </div>
      </div>
      <Button C={C} variant="primary" full icon="play" onClick={onStart} disabled={!plan.total}>{t("Начать")}</Button>
    </div>
  );
  const planBox = (
    <div data-panel="" style={box}>
      <div style={{ fontSize: 12.5, color: C.mid, marginBottom: 6 }}>{t("План на сегодня")}</div>
      <div data-display="" style={{ fontSize: 22, color: C.text, marginBottom: 8 }}>{plan.done} / {plan.all}</div>
      <div role="progressbar" aria-label={t("План на сегодня")} aria-valuemin={0} aria-valuemax={plan.all} aria-valuenow={plan.done}
        style={{ height: 6, borderRadius: 3, background: C.surface, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${plan.total === 0 && plan.done > 0 ? 100 : pct}%`, background: C.blueMid, borderRadius: 3 }} />
      </div>
    </div>
  );
  const streakBox = (
    <div data-panel="" style={box}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: C.gold || C.warm, fontSize: 15.5, fontWeight: 700 }}>
        <Icon n="flame" s={17} />{t("Стрик {0} {1}", [streak.count, ruPlural(streak.count, t("день"), t("дня"), t("дней"))])}
      </div>
      <div style={{ fontSize: 12, color: C.faint, marginTop: 4, paddingLeft: 25 }}>{t("Рекорд: {0}", [streak.best])}</div>
    </div>
  );

  if (compact) {
    return (
      <div style={{ display: 'grid', gap: 10, gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
        <div style={{ gridColumn: '1 / -1' }}>{review}</div>
        {planBox}
        {streakBox}
      </div>
    );
  }
  return <div style={{ display: 'flex', flexDirection: 'column', gap: 12, margin: '16px 0 0' }}>{review}{planBox}{streakBox}</div>;
}
